import React, { FC } from "react";

export const BrandDots: FC<JSX.IntrinsicAttributes> = (props) => {
  return (
    <svg
      width="11.555532"
      height="25.964525"
      viewBox="0 0 11.555532 25.964525"
      fill="none"
      version="1.1"
      id="svg4"
      {...props}
    >
      <path
        d="M 4.4709667,0.51237161 C 3.5967641,0.69521731 2.7774361,1.0960003 2.0822637,1.6808401 1.3870913,2.2656801 0.83652062,3.0173893 0.4771167,3.8723543 -0.18399648,5.5855601 0.25070901,7.388908 1.2423759,8.9170371 c 0.4902651,0.7814553 1.1508018,1.4295489 1.927105,1.8908069 0.7762935,0.461258 1.6461217,0.722459 2.5376957,0.762023 4.7410404,0 6.9190134,-4.8595864 4.9809524,-8.5422707 C 9.7236676,1.2099878 7.6588172,0.30356131 5.7071766,0.36525515 5.2986936,0.37861365 4.8923299,0.43262601 4.493597,0.52659429"
        fill="#ff9800"
        id="path2"
        style={{ strokeWidth: 0.972092 }}
      />
      <g
        style={{ fill: "none" }}
        id="g19"
        transform="matrix(0.97209233,0,0,0.97209233,0.17251708,14.486241)"
      >
        <path
          d="M 7.07903,11.2226 C 8.40443,10.8869 9.56185,10.0432 10.3232,8.85762 11.0845,7.67206 11.3945,6.23066 11.1922,4.81743 10.8195,2.28368 9.38949,1.02902 7.54951,0.301605 6.64037,-0.0278981 5.66224,-0.0887663 4.72228,0.125653 3.78232,0.340072 2.91679,0.821499 2.22056,1.51721 0.0312234,3.58716 -0.676797,7.07291 1.22374,9.5676 c 1.44869,1.8942 3.75911,2.1334 5.85529,1.655 z"
          fill="#ff478f"
          id="path10"
        />
      </g>
    </svg>
  );
};
